import React  from 'react';
import PercentageComponentProto from './percentage-proto.jsx';


export default function renderPercentageInList(id, props) {
    return <PercentageComponentProto renderMode="list" id={id} {...props} />;
}